document.addEventListener('DOMContentLoaded', function(){
    const itemsTitle = document.querySelectorAll('.collapsible__content .item__title');

    let contentActive = document.querySelector('.content__item.active');

    itemsTitle.forEach(itemTitle => {
        itemTitle.addEventListener('click', (e) => {
            e.preventDefault();
            const currentActive = itemTitle.closest('.content__item');
            contentActive.classList.remove('active');

            currentActive.classList.add('active');
            contentActive = currentActive;
        });
    });
});